import { Trans } from "react-i18next";
import { Typography, TypographyProps } from "@mui/material";

export interface TextProps extends TypographyProps {
  children?: string | number | JSX.Element | JSX.Element[] | React.ReactNode;
  i18nKey?: string;
  i18nVariable?: object;
  isBold?: boolean;
  forId?: string;
  component?: any;
}

const Text = ({
  children,
  i18nKey,
  i18nVariable,
  isBold,
  forId,
  component,
  ...otherProps
}: TextProps) => {
  const providedClassName = otherProps.className ?? "";
  const fontWeightMatch = providedClassName.match(
    /(?:^|\s)!?font-(thin|extralight|light|normal|medium|semibold|bold|extrabold|black)(?:\s|$)/,
  );
  const fontWeights: Record<string, number> = {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  };
  const resolvedFontWeight = fontWeightMatch
    ? fontWeights[fontWeightMatch[1]]
    : isBold
    ? 600
    : undefined;

  const customizeProps = {
    ...otherProps,
    className: `${isBold ? "font-semibold" : ""} ${providedClassName}`,
    style:
      resolvedFontWeight !== undefined
        ? { fontWeight: resolvedFontWeight, ...otherProps.style }
        : otherProps.style,
  };

  const i18nKeyValue = i18nKey ?? children;

  return (
    <WithLabelWrapper
      forId={component === "label" ? undefined : forId}
      className={customizeProps.className}>
      {/* @ts-ignore */}
      <Typography {...customizeProps} htmlFor={forId} component={component}>
        {i18nKey ? (
          <Trans components={{ bold: <strong /> }} values={i18nVariable}>
            {i18nKeyValue}
          </Trans>
        ) : (
          i18nKeyValue
        )}
      </Typography>
    </WithLabelWrapper>
  );
};

const WithLabelWrapper = ({
  children,
  forId,
  className,
}: {
  children: React.ReactNode | JSX.Element | JSX.Element[];
  forId?: string;
  className?: string;
}) => {
  if (forId) {
    return (
      <label htmlFor={forId} className={className}>
        {children}
      </label>
    );
  }
  return <>{children}</>;
};

export default Text;
